import { TTintService } from '../types/service-cookie.type';

type TProps = {
  servicesFromCookies: TTintService[];
  selectedColor: string;
  newQuantity: number;
  hex: string;
};

export const getServicesWithUpdatedQuantity = ({
  servicesFromCookies,
  selectedColor,
  newQuantity,
  hex,
}: TProps) =>
  servicesFromCookies.map(service => {
    if (service?.parameters?.color === selectedColor) {
      return {
        ...service,
        quantity: newQuantity,
        hex,
      };
    }

    return service;
  });
